export enum SubscriptionBillingFrequencyEnum {
  // DAILY = 'daily',
  // WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTER = 'quarter',
  HALF_YEARLY = 'half_yearly',
  ANNUALLY = 'annually',
}
